import MyCadastre from "../views/configuration/myRegister";
import PaymentOptions from "../views/configuration/paymentOptions";
import PlansTax from "../views/configuration/plansTax";
import Password from "../views/configuration/password";
// import Documents from "../views/configuration/documents";

import General from "../views/configuration/general";

//Assets
import MyCadastreIcon from "../assets/icons/company.svg";
import MyCadastreIconHover from "../assets/icons/companyHover.svg";
import PaymentOptionsIcon from "../assets/icons/bank.svg";
import PaymentOptionsIconHover from "../assets/icons/bankHover.svg";
import PasswordIcon from "../assets/icons/password.svg";
import PasswordIconHover from "../assets/icons/passwordHover.svg";
// import DocumentsIcon from "../assets/icons/cloud.svg";
// import DocumentsIconHover from "../assets/icons/cloudHover.svg";
import PlanTaxIcon from "../assets/icons/pay-order.svg";
import PlanTaxIconHover from "../assets/icons/pay-orderHover.svg";
import GeneralIcon from "../assets/icons/gear.svg";
import GeneralIconHover from "../assets/icons/gearHover.svg";


const routesConfiguration = [
    {
        id: "cm6a1",
        path: "/my-cadastre",
        name: "Meu Cadastro",
        icon: MyCadastreIcon,
        iconHover: MyCadastreIconHover,
        layout: "/configuration",
        component: MyCadastre,
        redirect: false,
    },
    
    {
        id: "cm6a2",
        path: "/payment-options",
        name: "Meios de pagamento",
        icon: PaymentOptionsIcon,
        iconHover: PaymentOptionsIconHover,
        layout: "/configuration",
        component: PaymentOptions,
        redirect: false,
    },
    
    {
        id: "cm6a3",
        path: "/password",
        name: "Senha",
        icon: PasswordIcon,
        iconHover: PasswordIconHover,
        layout: "/configuration",
        component: Password,
        redirect: false,
    },

    // {
    //     id: "cm6a4",
    //     path: "/documents",
    //     name: "Documentos",
    //     icon: DocumentsIcon,
    //     iconHover: DocumentsIconHover,
    //     layout: "/configuration",
    //     component: Documents,
    //     redirect: false,
    // },

    {
        id: "cm6a4",
        path: "/plan-tax",
        name: "Planos e taxas",
        icon: PlanTaxIcon,
        iconHover: PlanTaxIconHover,
        layout: "/configuration",
        component: PlansTax,
        redirect: false,
    },

    {
        id: "cm6a5",
        path: "/general",
        name: "Geral",
        icon: GeneralIcon,
        iconHover: GeneralIconHover,
        layout: "/configuration",
        component: General,
        redirect: false,
    },
]

export default routesConfiguration;